import { AuthGuard } from './shared/security/auth.guard';
import { AuthGuardAdmin } from './shared/security/auth.guard.admin';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FirebaseApp } from 'angularfire2';
import { firebaseConfig } from "../environments/firebase.config";
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import { ClientsService } from './shared/model/aSupprimer/client.service';
import { InstitutionsService } from './shared/services/institutions.service';
import { HttpModule } from '@angular/http';

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModules } from './material.module';
import { HeaderComponent } from './header/header.component';
import { appRoutingProviders, routing } from './app.routing';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { AuthService } from './shared/security/auth.service';
import { CommonModule } from '@angular/common';
import { PostalCodeDirective } from './shared/directives/postal-code/postal-code.directive';
import { PhoneDirective } from './shared/directives/phone/phone.directive';
import { DateDirective } from './shared/directives/date/date.directive';
import { WaitingSpinnerDirective } from './shared/directives/waiting-spinner/waiting-spinner.directive';
import { AddressValidationService } from './shared/address-validation/address-validation.service';
import { InstitutionUpdateComponent } from './institutions/institution-update/institution-update.component';
import { InstitutionFormComponent } from './institutions/institution-form/institution-form.component';
import { InstitutionCreateComponent } from './institutions/institution-create/institution-create.component';
import { InstitutionListComponent } from './institutions/institution-list/institution-list.component';
import { SaveService } from './shared/services/save.service';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { UserService } from './shared/services/user.service';
import { ConfigService } from './shared/services/config.service';
import { ChoiceResponsibleComponent } from './choice-responsible/choice-responsible.component';
import { ChoiceStudentComponent } from './choice-student/choice-student.component';
import { StudentDashboardComponent } from './student-dashboard/student-dashboard.component';
import { ResponsibleDashboardComponent } from './responsible-dashboard/responsible-dashboard.component';
import { UserCreateComponent } from './users/user-create/user-create.component';
import { UserUpdateComponent } from './users/user-update/user-update.component';
import { UserFormComponent } from './users/user-form/user-form.component';
import { ToolboxModule } from './toolbox/toolbox.module';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmDialogComponent,
    InstitutionCreateComponent,
    InstitutionFormComponent,
    InstitutionUpdateComponent,
    InstitutionListComponent,
    UserCreateComponent, 
    UserUpdateComponent,
    UserFormComponent, 
    StudentDashboardComponent,
    ResponsibleDashboardComponent,
    HeaderComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    ChoiceResponsibleComponent,
    ChoiceStudentComponent,
    PostalCodeDirective,
    PhoneDirective,
    DateDirective,
    WaitingSpinnerDirective
  ],
  entryComponents: [ConfirmDialogComponent],
  imports: [
    BrowserModule,
    CommonModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    HttpModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModules,
    routing,
    ToolboxModule
  ],
  providers: [appRoutingProviders, InstitutionsService, UserService, ConfigService,
    ClientsService, AuthService, AddressValidationService, SaveService, AuthGuard, AuthGuardAdmin],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/app.module.ts